// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NewsInteractionBar-cls1__d0b87751d5cd3c660865{/*!*/}.NewsInteractionBar-cls2__aacd8b06ec40c7bd4832{position:relative}.NewsInteractionBar-cls2__aacd8b06ec40c7bd4832.NewsInteractionBar-variant-dense___71b9e9c515ebd65e9a8{display:flex}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "NewsInteractionBar-cls1__d0b87751d5cd3c660865",
	"cls2": "NewsInteractionBar-cls2__aacd8b06ec40c7bd4832 NewsInteractionBar-cls1__d0b87751d5cd3c660865",
	"variant-dense": "NewsInteractionBar-variant-dense___71b9e9c515ebd65e9a8"
};
export default ___CSS_LOADER_EXPORT___;
